import styled from "@emotion/styled";

/* ================= DESKTOP HEADER ================= */
export const HeaderContainer = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  height: 4rem;
  padding: 0 ${({ theme }) => theme.spacing.xl};
  background-color: ${({ theme }) => theme.colors.surface};
  border-bottom: 0.0625rem solid ${({ theme }) => theme.colors.border};
  z-index: 30;
  position: sticky;
  top: 0;

  @media (max-width: 48rem) {
    height: 3.5rem;
    padding: 0 ${({ theme }) => theme.spacing.md};
  }
`;

export const DesktopNav = styled.nav`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 0;

  @media (max-width: 85rem) {
    display: none;
  }
`;

export const NavGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
  min-width: 0;
`;

export const Divider = styled.div`
  width: 0.0625rem;
  height: 1.5rem;
  background-color: ${({ theme }) => theme.colors.border};
  margin: 0 ${({ theme }) => theme.spacing.sm};
  flex-shrink: 0;
`;

export const StyledNavLink = styled.div<{ isActive?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
  padding: ${({ theme }) => theme.spacing.sm} 0.75rem;
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  background-color: ${({ theme, isActive }) =>
    isActive ? theme.colors.background : "transparent"};
  color: ${({ theme, isActive }) =>
    isActive ? theme.colors.primary : theme.colors.text};
  font-weight: ${({ isActive }) => (isActive ? "600" : "500")};
  font-size: ${({ theme }) => theme.typography.sizes.sm};
  cursor: pointer;
  transition: background-color 0.2s ease;
  white-space: nowrap;

  /* ОСЬ ГОЛОВНИЙ ФІКС: дозволяємо самому NavLink стискатися */
  min-width: 0;
  max-width: 100%;

  &:hover {
    background-color: ${({ theme }) => theme.colors.background};
  }
`;

export const DropdownWrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  min-width: 0;
  max-width: 100%;

  &:hover > div {
    display: flex;
  }
`;

export const DropdownMenu = styled.div<{
  $align?: "left" | "right" | "center";
}>`
  display: none;
  position: absolute;
  top: 100%;
  ${({ $align }) => {
    if ($align === "left") return "left: 0;";
    if ($align === "center") return "left: 50%; transform: translateX(-50%);";
    return "right: 0;";
  }}
  padding-top: 0.5rem;
  flex-direction: column;
  min-width: 12rem;
  max-width: 16rem;
  z-index: 100;

  & > div {
    background-color: ${({ theme }) => theme.colors.surface};
    border: 0.0625rem solid ${({ theme }) => theme.colors.border};
    border-radius: ${({ theme }) => theme.borderRadius.md};
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1);
    padding: ${({ theme }) => theme.spacing.sm};
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }
`;

export const TruncatedName = styled.span<{ $maxWidth?: string }>`
  max-width: ${({ $maxWidth }) => $maxWidth || "10rem"};
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
`;

export const NavText = styled.span`
  max-width: 5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
`;

export const AdminNavLink = styled.div<{ isActive?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
  padding: ${({ theme }) => theme.spacing.sm} 0.75rem;
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  color: ${({ theme }) => theme.colors.primary};
  background-color: ${({ theme, isActive }) =>
    isActive ? theme.colors.background : "transparent"};
  border: 0.0625rem dashed ${({ theme }) => theme.colors.primary};
  font-weight: 700;
  font-size: ${({ theme }) => theme.typography.sizes.sm};
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.2s ease;
  min-width: 0;

  &:hover {
    background-color: ${({ theme }) => theme.colors.background};
  }
`;

export const UserName = styled.span`
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: ${({ theme }) => theme.spacing.sm} 0.75rem;
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  font-size: ${({ theme }) => theme.typography.sizes.sm};
  color: ${({ theme }) => theme.colors.text};
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  transition: color 0.2s ease;
  min-width: 0;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

export const LogoutButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: ${({ theme }) => theme.spacing.sm} 0.75rem;
  background: transparent;
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  color: ${({ theme }) => theme.colors.text};
  font-size: ${({ theme }) => theme.typography.sizes.sm};
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.2s ease;
  width: 100%;
  justify-content: flex-start;

  &:hover {
    background-color: ${({ theme }) => theme.colors.background};
    color: ${({ theme }) => theme.colors.danger};
  }
`;

/* ================= MOBILE BUTTON & OVERLAY ================= */
export const MobileMenuButton = styled.button`
  display: none;
  background: transparent;
  border: none;
  color: ${({ theme }) => theme.colors.text};
  cursor: pointer;
  padding: 0.5rem;
  margin-right: -0.5rem;
  border-radius: ${({ theme }) => theme.borderRadius.sm};

  &:hover {
    background-color: ${({ theme }) => theme.colors.background};
  }

  @media (max-width: 85rem) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const MobileOverlay = styled.div<{ isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(0.125rem);
  z-index: 40;
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  visibility: ${({ isOpen }) => (isOpen ? "visible" : "hidden")};
  transition:
    opacity 0.3s ease,
    visibility 0.3s ease;

  @media (min-width: 85.01rem) {
    display: none;
  }
`;

/* ================= MOBILE SIDEBAR (DRAWER) ================= */
export const MobileDrawer = styled.aside<{ isOpen: boolean }>`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 18rem;
  background-color: ${({ theme }) => theme.colors.surface};
  border-left: 0.0625rem solid ${({ theme }) => theme.colors.border};
  z-index: 50;
  transform: translateX(${({ isOpen }) => (isOpen ? "0" : "100%")});
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  box-shadow: -0.25rem 0 1rem rgba(0, 0, 0, 0.1);
`;

export const DrawerHeader = styled.div`
  padding: ${({ theme }) => theme.spacing.lg};
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 0.0625rem solid ${({ theme }) => theme.colors.border};
`;

export const DrawerNavList = styled.nav`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing.md};
  gap: ${({ theme }) => theme.spacing.sm};
  overflow-y: auto;
  flex: 1;
`;

export const DrawerSectionTitle = styled.div`
  margin-top: ${({ theme }) => theme.spacing.md};
  margin-bottom: ${({ theme }) => theme.spacing.xs};
  font-size: 0.75rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.textMuted};
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
`;

export const DrawerControls = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md};
  padding: 0 ${({ theme }) => theme.spacing.md};
`;

export const DrawerControlGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm};

  & > select {
    width: 100%;
  }
`;

export const DrawerLabel = styled.label`
  font-size: 0.75rem;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.textMuted};
`;

export const DrawerAccount = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HeaderRight = styled.nav`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-left: auto;
  min-width: 0;

  @media (max-width: 85rem) {
    display: none;
  }
`;

export const ThemeSelect = styled.select`
  padding: 0.375rem 1.5rem 0.375rem 0.5rem;
  background-color: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text};
  border: 0.0625rem solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  font-size: 0.75rem;
  outline: none;
  cursor: pointer;
  appearance: none;
  background-image: url('data:image/svg+xml;utf8,<svg fill="%23888888" height="16" viewBox="0 0 24 24" width="16" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/></svg>');
  background-repeat: no-repeat;
  background-position-x: calc(100% - 0.25rem);
  background-position-y: 50%;
  text-overflow: ellipsis;
`;
